export default function BallByBallResult({ detail }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult">
        <img src="https://wver.sprintstaticdata.com/v230/static/admin/img/balls/ball-blank.png" />
        {' '}
        <span>{(detail?.rdesc || detail?.winnat || '') + ' '}</span>
      </div>
    </div>
  );
}
